import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import WarningModal from 'shared/lib/components/modals/warningModal';
import React, { useContext } from 'react';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { trashApi } from 'entities/trash/api/trashApi';

export type FinallyDeleteFileModalActions = {
  afterFileDelete?: (id: string) => void;
};

export default observer(function FinallyDeleteFileModalController({
  id,
  afterFileDelete,
  handleClose,
}: {
  id: string;
  handleClose: () => void;
} & FinallyDeleteFileModalActions) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  return (
    <>
      <WarningModal
        mainText={t('warnings.finallyDelete.fileMain')}
        secondText={t('warnings.finallyDelete.fileSecond')}
        isOpen={true}
        onCancel={handleClose}
        onContinue={async () => {
          try {
            await trashApi.deleteFile(id);
            afterFileDelete && afterFileDelete(id);
            handleClose();
          } catch (e) {
            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
            console.error(e);
            handleClose();
          }
        }}
      ></WarningModal>
    </>
  );
});
